__turbopack_context__.v({
  "carType": "CarType-module__eko-kW__carType",
  "carTypeTitle": "CarType-module__eko-kW__carTypeTitle",
  "carTypes": "CarType-module__eko-kW__carTypes",
  "image": "CarType-module__eko-kW__image",
  "layout": "CarType-module__eko-kW__layout",
});
